import React, { FC } from "react";
import { Form, Input, Radio, Row, Col, DatePicker, Button } from "antd";
import dayjs from "dayjs";
import { Tooltip } from "antd";
import {
  CheckCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../../../utils/notificationUtils";
import { errorMessageModal, warningMessageModal } from "../../../../utils/modalMessage";

interface PortalRegistrationStarHealthProps {
  editRegId: boolean;
  handleEditRegId: () => void;
  handleSubmitId: (values: any) => void;
  handleRegistration: () => void;
  form: any;
  portalData: any;
  showRegistrationId?: boolean;
  isSubmitted?: boolean;
  showVerifyButton?: boolean;
  isValidationLoading?: boolean;
  registrationValidationStatus?: any;
  handleClaimValidation?: () => void;
}

const PortalRegistrationStarHealth: FC<PortalRegistrationStarHealthProps> = ({
  editRegId,
  handleEditRegId,
  handleSubmitId,
  handleRegistration,
  form,
  portalData,
  showRegistrationId,
  isSubmitted,
  showVerifyButton,
  isValidationLoading,
  registrationValidationStatus,
  handleClaimValidation,
}) => {
  const onFinish = (values: any) => {
    if (editRegId) {
      handleSubmitId(values);
    } else {
      handleRegistration();
    }
  };

  const handleUpdateId = async () => {
    try {
      const values = await form.validateFields();
      await handleSubmitId(values);
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please fill all details before submitting");
      } else {
        errorMessage(err?.response?.data || "Please, Try again after sometime");
      }
    }
  };

  return (
    <div className="portal-registration-form">
      <Form
        form={form}
        name="starHealthPortalRegistration"
        onFinish={onFinish}
        layout="vertical"
      >
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              label="CLAIM TYPE"
              name="claimType"
              rules={[{ required: true, message: "Please select claim type" }]}
            >
              <Radio.Group>
                <Radio value="COVID">COVID</Radio>
                <Radio value="NON-COVID">NON-COVID</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="POLICY TYPE"
              name="policyType"
              rules={[{ required: true, message: "Please select policy type" }]}
            >
              <Radio.Group>
                <Radio value="INDIVIDUAL">INDIVIDUAL</Radio>
                <Radio value="GROUP">GROUP</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              label="MEDICAL ID"
              name="beneficiaryId"
              rules={[{ required: true, message: "Please enter medical ID" }]}
            >
              <Input
                disabled={portalData?.schemeRegistrationId}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="REGISTRATION DATE"
              name="registrationDate"
              rules={[
                { required: true, message: "Please select registration date" },
              ]}
            >
              <DatePicker
                format="DD-MM-YYYY HH:mm:ss"
                showTime
                style={{ width: "100%" }}
                disabled={portalData?.schemeRegistrationId}
              />
            </Form.Item>
          </Col>

          {
            Form.useWatch("policyType", form) === "GROUP" ? <Col span={6}>
            <Form.Item
              label="Employee ID"
              name="employeeId"
              // rules={[
              //   { required: true, message: "Please enter Employee id" },
              // ]}
            >
              <Input
                // disabled={true}
              />
            </Form.Item>
          </Col> : <></>
          }

          <Col span={6}>
            <Form.Item
              label="HOSPITAL PATIENT ID"
              name="patientOpdIpdNumber"
              rules={[
                { required: true, message: "Please enter hospital patient ID" },
              ]}
            >
              <Input
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="MEDICAL ID CARD NUMBER"
              name="beneficiaryId"
              rules={[
                {
                  required: true,
                  message: "Please enter medical ID card number",
                },
              ]}
            >
              <Input
                disabled={portalData?.schemeRegistrationId}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={6}>
            <Form.Item label="POLICY NAME" name="policyName">
              <Input
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="CLAIM REF NO." name="claimRefNo">
              <Input
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="POLICY NO." name="policyNumber">
              <Input
               disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={6}>
            <Form.Item label="POLICY INCEPTION DATE" name="policyDate">
              <DatePicker
                format="DD-MM-YYYY"
                style={{ width: "100%" }}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="POLICY START DATE" name="policyStartDate">
              <DatePicker
                format="DD-MM-YYYY"
                style={{ width: "100%" }}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="POLICY END DATE" name="policyEndDate">
              <DatePicker
                format="DD-MM-YYYY"
                style={{ width: "100%" }}
                disabled={true}
              />
            </Form.Item>
          </Col>

          {portalData?.schemeRegistrationId || showRegistrationId ? (
            !editRegId ? (
              <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                <Form.Item
                  label="REGISTRATION ID"
                  name="registrationId"
                  style={{ marginTop: "1.7rem", color: "black" }}
                  rules={[
                    {
                      required: true,
                      message: "Please input REGISTRATION ID",
                    },
                  ]}
                >
                  <Input
                    placeholder="Please input REGISTRATION ID"
                    disabled={portalData?.schemeRegistrationId || showRegistrationId}
                    style={{ color: "black" }}
                  />
                </Form.Item>
              </Col>
            ) : (
              <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                <Form.Item
                  label="REGISTRATION ID"
                  name="registrationId"
                  style={{ marginTop: "1.7rem", color: "black" }}
                  rules={[
                    {
                      required: true,
                      message: "Please input REGISTRATION ID",
                    },
                    {
                      pattern: /^\S+$/,
                      message: "REGISTRATION ID must not contain spaces",
                    },
                  ]}
                >
                  <Input
                    placeholder="Please input REGISTRATION ID"
                    //   disabled={portalData?.schemeRegistrationId}
                    style={{ color: "black" }}
                  />
                </Form.Item>
              </Col>
            )
          ) : (
            <></>
          )}
          {portalData?.schemeRegistrationId || showRegistrationId ? (
            !editRegId ? (
              <>
                {/* Hidden input element for copying */}
                <input
                  type="text"
                  id="hidden-copy-input"
                  value={portalData?.schemeRegistrationId || ""}
                  readOnly
                  style={{ position: "absolute", left: "-9999px" }}
                />

                {/* Copy Icon */}
                <Tooltip title="Copy Registration ID">
                  <CopyOutlined
                    style={{
                      paddingTop: "24px",
                      fontSize: "20px",
                      marginLeft: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const hiddenInput: any =
                        document.getElementById("hidden-copy-input");
                      if (hiddenInput) {
                        hiddenInput.select();

                        try {
                          const successful = document.execCommand("copy");
                          if (successful) {
                            successMessage(
                              "Registration ID copied to clipboard!"
                            );
                          } else {
                            errorMessage("Failed to copy Registration ID.");
                          }
                        } catch (err) {
                          errorMessage("Copy command failed!");
                        }
                      } else {
                        warningMessageModal("No Registration ID to copy!");
                      }
                    }}
                  />
                </Tooltip>
                {!portalData?.casePreAuthStarhealth?.claimId ? (
                  <Tooltip title="Edit Registration ID">
                    <EditOutlined
                      style={{
                        paddingTop: "24px",
                        fontSize: "20px",
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      onClick={handleEditRegId}
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                <Tooltip title="Cancel Update Registration ID">
                  <CloseOutlined
                    style={{
                      paddingTop: "24px",
                      fontSize: "20px",
                      marginLeft: "8px",
                      cursor: "pointer",
                    }}
                    onClick={handleEditRegId}
                  />
                </Tooltip>
                <Tooltip title="Save Registration ID">
                  <CheckOutlined
                    style={{
                      paddingTop: "24px",
                      fontSize: "20px",
                      marginLeft: "8px",
                      cursor: "pointer",
                    }}
                    onClick={handleUpdateId}
                  />
                </Tooltip>
              </>
            )
          ) : (
            <></>
          )}
        </Row>

        {portalData?.schemeRegistrationId ||
        (portalData?.visitStagesName?.toLowerCase()?.toString() ==
          "portal registration" &&
          (portalData?.stateName?.toLowerCase()?.toString() == "initiated" ||
            portalData?.stateName?.toLowerCase()?.toString() ==
              "submitted" || portalData?.stateName?.toLowerCase()?.toString() ==
              "manually submitted")) ? (
          <></>
        ) : (
          <Row justify="end" style={{ marginBottom: "0" }}>
            <Form.Item wrapperCol={{ span: 16 }} style={{ marginBottom: "0" }}>
              {
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                  }}
                >
                  PORTAL REGISTRATION
                </Button>
              }
            </Form.Item>
          </Row>
        )}
      </Form>

      {isSubmitted && showVerifyButton && handleClaimValidation ? (
        <div
          style={{
            marginTop: 12,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            loading={isValidationLoading}
            onClick={handleClaimValidation}
            style={{
              backgroundColor: "rgb(0, 76, 143)",
              color: "#fff",
              boxShadow: "0px 2px 8px 0px #00000040",
              minWidth: 140,
            }}
          >
            {registrationValidationStatus ? "View" : "Verify"}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default React.memo(PortalRegistrationStarHealth);
